import React from 'react';
import PropTypes from 'prop-types';
import { Confirmation } from '../ordination/confirmation';
import PostOrdination from '../ordination/post_ordination';
import MinisterHelper from './minister_helper';

class PostApplication extends React.Component {
  constructor(props) {
    super(props);
    document.title = 'Ordination Success'
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  redirect() {
    // Redirect Tennessee Ministers to this page instead
    window.history.pushState({}, null, '/weddings-by-state/tennessee/minister-rights')
    window.history.go()
  }
  
  render() {
    // if (this.props.minister.state_id == 54) {
    //   setTimeout(() => this.redirect(), 2000);
    // }
    return (
      <div className='ordination_success_page'>
        {/* {this.props.minister.state_id == 54 &&
          <div>
            <h1>
              Your minister rights in Tennessee may differ from other states.
            </h1>
            <p>
              Redirecting you to an informational page about your rights.
            </p>
          </div>
        } */}
        {/* {this.props.minister.state_id != 54 && */}
        <div>
          <h1>ORDINATION SUCCESS</h1>
          <p id='newministername'>{ MinisterHelper.fullName(this.props.minister) }</p>
          <h3>You are Now an AMM Minister!</h3>
          <br/>
          <Confirmation minister={ this.props.minister } clearPartialMinister={ this.props.clearPartialMinister } className='post-ord-panel'/>
          <PostOrdination className='post-ord-panel' minister={ this.props.minister } /> 
        </div>
        {/* } */}
      </div>
    )
  }
}

PostApplication.propTypes = {
  minister: PropTypes.object.isRequired,
  clearPartialMinister: PropTypes.func.isRequired,
};

export default PostApplication;